module.exports = __webpack_public_path__ + "965ddfc2d4b7144b863c1b0179291243.MP3";